import { useRef, useState, useEffect } from "react";
import styled from "styled-components";

import OaFormAlerts from "pages/components/OaFormAlerts";
import FlightMarkupTable from "./FlightMarkupTable";
import CustomTabs from "./CustomTabs";
// import CustomLoader from "components/CustomLoader";
import React from "react";
import { useHistory } from "react-router-dom";

const FlightMarkupForm = (props) => {
  const [domesticMarkup, setDomesticMarkup] = useState([]);
  const [domesticMarkupArray, setDomesticMarkupArray] = useState([]);
  const [internationalMarkup, setInternationalMarkup] = useState([]);
  const [internationalMarkupArray, setInternationalMarkupArray] = useState([]);
  const [sotoMarkup, setSotoMarkup] = useState([]);
  const [sotoMarkupArray, setSotoMarkupArray] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [infoText, setInfoText] = useState("");
  const [formInitialValuesDom, setFormInitialValuesDom] = useState(null);
  const [formInitialValuesInt, setFormInitialValuesInt] = useState(null);
  const [formInitialValuesSot, setFormInitialValuesSot] = useState(null);
  const [reloadFlag, setReloadFlag] = useState(false);
  const history = useHistory();

  const tabs = ["DOMESTIC CARRIERS", "INTERNATIONAL", "SOTO FARE"];

  const contents = [
    <FlightMarkupTable
      type="domesticCarrierMarkupValues"
      initialValues={formInitialValuesDom}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      data={domesticMarkupArray}
      markupList={props.markupList}
      setIsError={setIsError}
      setIsSuccess={setIsSuccess}
      setIsSaving={setIsSaving}
      setInfoText={setInfoText}
      setReloadFlag={setReloadFlag}
    />,
    <FlightMarkupTable
      type="internationalCarrierMarkupValues"
      initialValues={formInitialValuesInt}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      data={internationalMarkupArray}
      markupList={props.markupList}
      setIsError={setIsError}
      setIsSuccess={setIsSuccess}
      setIsSaving={setIsSaving}
      setInfoText={setInfoText}
      setReloadFlag={setReloadFlag}
    />,
    <FlightMarkupTable
      type="sotoCarrierMarkupValues"
      initialValues={formInitialValuesSot}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      data={sotoMarkupArray}
      markupList={props.markupList}
      setIsError={setIsError}
      setIsSuccess={setIsSuccess}
      setIsSaving={setIsSaving}
      setInfoText={setInfoText}
      setReloadFlag={setReloadFlag}
    />,
  ];

  function populateInitialValues(value, initialValues, key) {
    if (value.Markups != undefined) {
      value.Markups.map(function(rows, ikey) {
        if (rows.markUpValues !== undefined) {
          rows.markUpValues.map((row, ikeys) => {
            initialValues[key + "__" + ikey + "__" + ikeys] =
              row.actualTransactionValue;
          });
        }
      });
    }
  }

  function setInitialValues() {
    let domInitialValues = {};
    let intInitialValues = {};
    let sotoInitialValues = {};

    for (let [key, value] of Object.entries(props.markupList)) {
      console.log("key", key);
      switch (key) {
        case "domesticCarrierMarkupValues": {
          populateInitialValues(value, domInitialValues, key);
          continue;
        }
        case "internationalCarrierMarkupValues": {
          populateInitialValues(value, intInitialValues, key);
          continue;
        }
        case "sotoCarrierMarkupValues": {
          populateInitialValues(value, sotoInitialValues, key);
          continue;
        }
      }
    }

    setFormInitialValuesDom(domInitialValues);
    setFormInitialValuesInt(intInitialValues);
    setFormInitialValuesSot(sotoInitialValues);
  }

  function dataArrDomestic() {
    const newArr = [];

    domesticMarkup &&
      domesticMarkup.map((rows, idx) => {
        rows.markUpValues.map((row, index) => {
          let supplier = row.supplier;
          switch (supplier) {
            case "Tripjack": {
              supplier = "Supplier 1";
              break;
            }
            case "tbo": {
              supplier = "Supplier 2";
              break;
            }
            case "kafila": {
              supplier = "Supplier 3";
              break;
            }
          }
          let obj = {
            id: index,
            carrier: `${row.carrier}`,
            airline: `${row.airlines}`,
            supplier: `${supplier}`,
            fareType: `${row.fareType}`,
            markupType: `${
              row.markupType.charAt(0) === "F"
                ? "FIXED"
                : row.markupType.charAt(0) === "P"
                ? "Percentage"
                : ""
            }`,
            markupAmount: `${row.actualTransactionValue}`,
            formFieldName:
              "domesticCarrierMarkupValues" + "__" + idx + "__" + index,
          };
          newArr.push(obj);
        });
      });
    setDomesticMarkupArray(newArr);
  }

  function dataArrInternational() {
    const newArr = [];
    internationalMarkup &&
      internationalMarkup.map((rows, idx) => {
        rows.markUpValues.map((row, index) => {
          let supplier = row.supplier;
          switch (supplier) {
            case "Tripjack": {
              supplier = "Supplier 1";
              break;
            }
            case "tbo": {
              supplier = "Supplier 2";
              break;
            }
            case "kafila": {
              supplier = "Supplier 3";
              break;
            }
          }
          newArr.push({
            id: index,
            carrier: `${row.carrier}`,
            airline: `${row.airlines}`,
            supplier: `${supplier}`,
            fareType: `${row.fareType}`,
            markupType: `${
              row.markupType.charAt(0) === "F"
                ? "FIXED"
                : row.markupType.charAt(0) === "P"
                ? "Percentage"
                : ""
            }`,
            markupAmount: `${row.actualTransactionValue}`,
            formFieldName:
              "internationalCarrierMarkupValues" + "__" + idx + "__" + index,
          });
        });
      });
    setInternationalMarkupArray(newArr);
  }

  function dataArrSoto() {
    const newArr = [];
    sotoMarkup &&
      sotoMarkup.map((rows, idx) => {
        rows.markUpValues.map((row, index) => {
          let supplier = row.supplier;
          switch (supplier) {
            case "Tripjack": {
              supplier = "Supplier 1";
              break;
            }
            case "tbo": {
              supplier = "Supplier 2";
              break;
            }
            case "kafila": {
              supplier = "Supplier 3";
              break;
            }
          }
          newArr.push({
            id: index,
            carrier: `${row.carrier}`,
            airline: `${row.airlines}`,
            supplier: `${supplier}`,
            fareType: `${row.fareType}`,
            markupType: `${
              row.markupType.charAt(0) === "F"
                ? "FIXED"
                : row.markupType.charAt(0) === "P"
                ? "Percentage"
                : ""
            }`,
            markupAmount: `${row.actualTransactionValue}`,
            formFieldName:
              "sotoCarrierMarkupValues" + "__" + idx + "__" + index,
          });
        });
      });
    setSotoMarkupArray(newArr);
  }

  useEffect(() => {
    if (props.markupList) {
      setIsLoading(true);
      setDomesticMarkup(props.markupList.domesticCarrierMarkupValues?.Markups);
      setInternationalMarkup(
        props.markupList.internationalCarrierMarkupValues?.Markups
      );
      setSotoMarkup(props.markupList.sotoCarrierMarkupValues?.Markups);
      setInitialValues();
    }
  }, [props.markupList]);

  useEffect(() => {
    new Promise((resolve, reject) => {
      if (domesticMarkup) {
        dataArrDomestic();
      }

      if (internationalMarkup) {
        dataArrInternational();
      }

      if (sotoMarkup) {
        dataArrSoto();
      }
      resolve(
        domesticMarkupArray && internationalMarkupArray && sotoMarkupArray
      );
    }).then(() => setIsLoading(false));
  }, [domesticMarkup, internationalMarkup, sotoMarkup]);

  useEffect(() => {
    if(reloadFlag) {
      setReloadFlag(false);
      window.location.reload();
    }
  }, [reloadFlag]);

  return (
    <RootContainer>
      <OaFormAlerts
        isError={isError}
        isSuccess={isSuccess}
        isSaving={isSaving}
        infoText={infoText}
        setIsSaving={setIsSaving}
        setInfoText={setInfoText}
        setIsError={setIsError}
        setIsSuccess={setIsSuccess}
      />
      <div className="form-container-wrapper">
        <div className="form-container">
          {domesticMarkupArray &&
          internationalMarkupArray &&
          sotoMarkupArray &&
          !isLoading ? (
            <CustomTabs tabs={tabs} contents={contents} />
          ) : (
            <div>Loading</div>
          )}
        </div>
      </div>
    </RootContainer>
  );
};

export default FlightMarkupForm;

const RootContainer = styled.div`
  .form-container-wrapper {
    width: 100%;
    .form-container {
      width: 100%;
      min-height: 101px;
      border-radius: 8px;
      position: relative;

      .tabs {
        padding-bottom: 10px;
      }

      .tab {
        font-size: 1em;
        font-weight: 500;

        &.active {
          border-bottom: 3px solid;
        }
      }

      .tab-content {
      }
    }
  }

  .form-row {
    display: flex;
    width: 100%;
  }

  .form-element {
    padding: 10px 10px;
    text-align: left;
    // flex: 1;
    input {
      width: 70px;

      height: 40px;
      &:placeholder {
        font-weight: 500;
        font-size: 14px;
      }
      &:focus {
        outline: none;
      }
    }
    label,
    .text-header {
      font-size: 13px;
      padding: 0 8px;
      width: 100%;
      text-transform: uppercase;
      font-weight: 500;
    }
    select {
      display: block;

      padding: 11px 3px;
      margin-top: 5px;
      border-radius: 3px;
      width: 100%;

      &:focus {
        outline: none;
      }
    }
  }

  .btn-element {
    // padding-top: 45px;
    position: relative;
    padding: 0 10px 10px;
    button {
      padding: 8px 15px 8px 10px;
      text-transform: uppercase;
    }
  }

  .btn-submit {
    padding: 0 15px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;

    transition: ease 0.4s;
    &:disabled {
      cursor: not-allowed;
    }
  }

  .w25p {
    width: 25%;
  }

  .w30p {
    width: 33.3%;
  }

  .w50p {
    width: 50%;
  }
`;
